import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import ReCAPTCHA from 'react-google-recaptcha';
import { useCallback } from 'preact/compat';
import AwesomeDebouncePromise from 'awesome-debounce-promise';
import { useController, useFormContext, } from 'react-hook-form';
import FormGroup from '@enquiryForm/components/FormGroup';
import FormLabel from '@enquiryForm/components/FormLabel';
import API from '@widgets/shared/API/connection';
const debouncedVerify = AwesomeDebouncePromise(API.siteVerify, 500);
function CaptchaInput(props) {
    const { inputAttrs, labelAttrs } = props;
    const { name } = inputAttrs;
    const { control } = useFormContext();
    const { field: { onChange } } = useController({ name, control });
    const handleInputChanged = useCallback((newValue) => {
        if (newValue) {
            debouncedVerify(newValue).then((res) => {
                const { success } = res;
                console.log('Capthca recieved: ', res);
                onChange(success);
            });
        }
    }, [onChange]);
    const handleError = useCallback(() => {
        onChange(false);
    }, [onChange]);
    return (_jsxs(FormGroup, { children: [_jsx(FormLabel, { ...labelAttrs }), _jsx(ReCAPTCHA, { sitekey: "6LejRigqAAAAAKou3sBetGybwPyhGKO_7UTB-tLO", ...inputAttrs, onChange: handleInputChanged, onErrored: handleError, onExpired: handleError })] }));
}
export default CaptchaInput;
